"use client";

import { useState, type ReactNode } from "react";

export type DisclaimerTab = {
  id: string;
  label: string;
  icon: string;
  title: string;
  content: ReactNode;
};

/**
 * Client island — tab buttons only. Every panel is rendered by the server and
 * stays in the DOM so the copy remains crawlable; inactive ones are hidden.
 */
export function PillarDisclaimerTabs({ tabs }: { tabs: DisclaimerTab[] }) {
  const [activeTab, setActiveTab] = useState(0);

  return (
    <>
      <div className="disc-tabs" role="tablist" aria-label="Disclaimer categories">
        {tabs.map((tab, index) => (
          <button
            key={tab.id}
            id={`disc-tab-${tab.id}`}
            type="button"
            role="tab"
            aria-selected={activeTab === index}
            aria-controls={`disc-panel-${tab.id}`}
            className={`disc-tab-btn${activeTab === index ? " active" : ""}`}
            onClick={() => setActiveTab(index)}
          >
            <span className="disc-tab-icon" aria-hidden="true">
              {tab.icon}
            </span>
            <span className="disc-tab-label">{tab.label}</span>
          </button>
        ))}
      </div>

      <div className="disc-tab-panel-wrap">
        {tabs.map((tab, index) => {
          const isActive = activeTab === index;
          return (
            <div
              key={tab.id}
              id={`disc-panel-${tab.id}`}
              role="tabpanel"
              aria-labelledby={`disc-tab-${tab.id}`}
              className={`disc-tab-pane${isActive ? " active" : ""}`}
              hidden={!isActive}
            >
              <div className="disc-tab-pane-head">
                <span className="disc-tab-pane-icon" aria-hidden="true">
                  {tab.icon}
                </span>
                <h3>{tab.title}</h3>
              </div>
              {tab.content}
            </div>
          );
        })}
      </div>
    </>
  );
}
